function updateLineTotal(qtyElem) {
  const qtyNum = qtyElem.value;
  const itemPriceElem = qtyElem.parentElement.parentElement.querySelector('.cart__item__price__money');
  const lineTotalElem = qtyElem.parentElement.parentElement.querySelector('.cart__item__total__money');
  const itemPrice = itemPriceElem.textContent.replace(/[^0-9]+/g, '');
  const currencySymbol = itemPriceElem.textContent.trim().substring(0, 1);
  lineTotalElem.textContent = currencySymbol + ((itemPrice * qtyNum) / 100).toFixed(2);
}

function updateCartSubtotal(cartElem) {
  const cartSubtotalElem = cartElem.querySelector('.cart__subtotal__money--total .money');
  const lineTotalElemArr = cartElem.getElementsByClassName('cart__item__total__money');
  const currencySymbol = lineTotalElemArr[0].textContent.trim().substring(0, 1);
  let runningTotal = 0;
  for (let lineTotalElem of lineTotalElemArr) {
    runningTotal += parseFloat(lineTotalElem.textContent.replace(/[^0-9]+/g, ''));
  }
  cartSubtotalElem.textContent = currencySymbol + (runningTotal / 100).toFixed(2);
}

function observeCart(cartElem) {
  const minSpendBannerElem = cartElem.getElementsByClassName('notice--minspend')[0];
  // run early to set showUpdate when page loads
  if (checkMinSpend(cartElem, minSpendBannerElem, minSpendNum)) {
    showUpdate = true;
  }
  const observerCallback = function(mutationListArr, observerObj) {
    mutationListArr.forEach(function(mutationObj) {
      switch (mutationObj.target.classList[0]) {
        case 'cart__item__total__money':
          updateCartSubtotal(cartElem);
        case 'cart__subtotal__money--total':
          checkMinSpend(cartElem, minSpendBannerElem, minSpendNum);
          break;
      }
    });
  }
  const observerObj = new MutationObserver(observerCallback);
  observerObj.observe(cartElem, {childList: true, subtree: true});
}

function showHideBtns(elem, showBool) {
  if (showBool) {
    elem.classList.remove('btn--hide');
    return;
  }
  elem.classList.add('btn--hide');
}

// values need to be watched with events, not with MutationObserver
function watchQtyInputs(qtyInputElems, updateBtnElems, checkoutBtnElems) {
  for (let qtyInputElem of qtyInputElems) {
    qtyInputElem.addEventListener('change', function(changedElem) {
      showHideBtns(updateBtnElems, true);
      showHideBtns(checkoutBtnElems, false);
      if ('function' === typeof updateLineTotal) {
        updateLineTotal(changedElem.target);
      }
    });
  }
}

function checkMinSpend(cartElem, minSpendBannerElem, minSpendNum) {
  if (0 == minSpendNum) {
    return false;
  }
  let subTotalElem = cartElem.querySelector('.cart__subtotal__money--total .money');
  subTotalNum = subTotalElem.textContent.substring(1) * 100;
  if (subTotalNum < minSpendNum) {
    minSpendBannerElem.classList.add('notice--minspend--show');
    return true;
  } else {
    minSpendBannerElem.classList.remove('notice--minspend--show');
    return false;
  }
}

const cartElem = document.getElementsByClassName('cart')[0];
const updateBtnElem = cartElem.getElementsByClassName('cart__update')[0];
const checkoutBtnElem = cartElem.getElementsByClassName('cart__checkout')[0];
const qtyInputElems = cartElem.getElementsByClassName('cart__item__qty__input');
watchQtyInputs(qtyInputElems, updateBtnElem, checkoutBtnElem);
observeCart(cartElem);
if (true == showUpdate) {
  showHideBtns(updateBtnElem, true);
  showHideBtns(checkoutBtnElem, false);
}
